import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const initialState = {
  id: localStorage.getItem('id')||null,
  username: localStorage.getItem('username') || null,
  token: localStorage.getItem('token') || null,
  status: 'idle',
  error: null,
  message: null,
};

export const signIn = createAsyncThunk(
  'auth/signIn',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await instance.post('/auth/signin', credentials);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        return rejectWithValue("email et/ou mot de passe incorrect(s)");
      }
      return rejectWithValue('An unknown error occurred during sign-in.');
    }
  }
);

export const signUp = createAsyncThunk(
  'auth/signUp',
  async (userInfo, { rejectWithValue }) => {
    try {
      const response = await instance.post('/auth/signup', userInfo);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue('An unknown error occurred during sign-up.');
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.username = null;
      state.token = null;
      state.id = null;
      localStorage.removeItem('username');
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('loginTime')
    },
    resetAuthState: (state) => {
      state.status = 'idle';
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.username = action.payload.username;
        state.token = action.payload.accessToken;
        state.id = action.payload.id;
        state.message = 'Login successful!';
        state.error = null; 
        localStorage.setItem('username', action.payload.username);
        localStorage.setItem('token', action.payload.accessToken);
        localStorage.setItem('id', action.payload.id);
        localStorage.setItem('loginTime', Date.now().toString())
      })
      .addCase(signIn.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      .addCase(signUp.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.message = 'Registration successful! Please sign in.';
        state.error = null; // Clear any previous error
      })
      .addCase(signUp.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { logout, clearMessage, resetAuthState } = authSlice.actions;

export default authSlice.reducer;